<template>
  <custom-dialog
    color="primary"
    ref="dialog"
    icon="mdi-pause"
    store-modal
    :title="generateMessage('requests.actions.pause')"
  >
    <v-form ref="form">
      <div class="d-flex mt-2">
        <v-select
          class="mx-2 test-select"
          v-model="pause_reason"
          item-text="label"
          item-value="code"
          :items="items"
          :placeholder="generateMessage('requests.actions.pause_reason')"
          color="primary"
          clearable
          outlined
          dense
        />
      </div>
      <custom-text-area
        class="mx-2 test-textarea"
        color="primary"
        v-model="pause_comment"
        :maxCharacter="60"
        errorTooLongMsg="Maximum 60 caractères"
        :label="generateMessage('requests.actions.comment')"
      />
    </v-form>
    <template v-slot:actions>
      <div class="d-flex justify-end">
        <v-btn
          small
          color="primary"
          :disabled="!valid"
          :loading="isLoading"
          @click="pause"
          class="mx-2 text-validate-btn"
        >
          {{ generateMessage('requests.actions.validate') }}
        </v-btn>
        <v-btn small class="mx-2" @click="cancel">
          {{ generateMessage('requests.actions.cancel') }}
        </v-btn>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import CustomDialog from '@/components/dialogs/CustomDialog';
import CustomTextArea from '@/components/CustomTextArea';
import { selfAssign } from '@/services/api/internal/requestActions/selfAssign.api';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

export default {
  name: 'PauseDialog',
  components: {
    CustomTextArea,
    CustomDialog,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    generateMessage,
    selfAssign,
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    pause() {
      this.isLoading = true;
      this.selfAssign(this.requestId, {
        is_paused: 'O',
        pause_reason_id: this.pause_reason,
        pause_comment: this.pause_comment,
      })
        .then(() => {
          this.cancel();
          this.$store.dispatch('requests/refreshItems');
          this.$store.dispatch('requests/removeCurrent', this.requestId);
          this.$store.dispatch('boilerplate/setModalClosed');
        })
        .catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('REJECT', err)
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initForm() {
      this.pause_reason = null;
      this.pause_comment = '';
      this.valid = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  computed: {
    ...mapGetters({
      items: 'requests/pause_reason/items',
    }),
    valid() {
      return this.pause_reason || this.pause_comment.length;
    },
  },
  watch: {
    requestId: {
      handler() {
        this.initForm();
      },
      immediate: true,
    },
  },
  data() {
    return {
      pause_reason: null,
      pause_comment: '',
      isLoading: false,
    };
  },
};
</script>
